import React from "react";
import {Box, ThemeProvider} from "@mui/material";
import Menu from "../components/Menu";
import {theme} from "../theme/theme";

export const Website = ({children}) => {
    return(
        <ThemeProvider theme={theme}>
            <Box width='100vw'>
                <Menu/>
                {children}
            </Box>
        </ThemeProvider>
    )
}
